module.exports = __webpack_public_path__ + "1ea94474c3b5f2afef8f0c27b3638055.svg";